import { Card, CardContent } from '@e2n/ui/v2';
import { useDatevAuthContext } from '../../lib/DatevAuthContext';
import { Authorized } from './Authorized';
import { NotAuthorized } from './NotAuthorized';

export function DatevAuthCard() {
  const { status, loading } = useDatevAuthContext();

  const isAuthorized = !!status?.authorized;

  return (
    <Card>
      <CardContent>
        {loading ? null : isAuthorized ? <Authorized /> : <NotAuthorized />}
      </CardContent>
    </Card>
  );
}
